import { useEffect } from "react";
import env from "../../../../config/env"
import { click } from "@testing-library/user-event/dist/click";

const GoogleDrivePickers = ({ files_send_to_parent, setSpinnerLoading }) => {
  const GDriveURL = `${env.GDriveURL}`;
  const openPicker = () => {
    const width = 700;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const popup = window.open(
      GDriveURL,
      "Google Drive Picker",
      `popup=yes,width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no`
    );

    if (!popup) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    const interval = setInterval(() => {
      if (popup.closed) {
        clearInterval(interval);
        console.log("Popup closed by user.");
      } else {
        try {
          // Send to popup origin instead of "*"
          const popupOrigin = new URL(GDriveURL).origin;
          popup.postMessage({ action: "openPicker" }, popupOrigin);
          clearInterval(interval); // Stop the interval after message is sent
        } catch (err) {
          console.error("Error posting message:", err);
        }
      }
    }, 500);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      // Validate origin
      try {
        const allowedOrigin = new URL(GDriveURL).origin;
        if (event.origin !== allowedOrigin) return;
      } catch (err) {
        return;
      }
      if (event.data?.action === "filesSelected") {
        setSpinnerLoading(true)
        files_send_to_parent(event.data.files);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [files_send_to_parent, GDriveURL]);

  return (
    <div>
      <button onClick={openPicker} style={{ fontSize: '12px', background: "none", border: "none" }}>
        Connect Google Drive
      </button>
    </div>
  );
};

export default GoogleDrivePickers;
